import { render } from "./ChevronSelectorVerticalIcon.vue?vue&type=template&id=38822b95"
import script from "./ChevronSelectorVerticalIcon.vue?vue&type=script&lang=js"
export * from "./ChevronSelectorVerticalIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__